import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApiV2 } from "../../DbCenterBaseApiV2";

export class CompontentConfigApi extends DbCenterBaseApiV2 {

    public get ControllerName(): any {
        return 'compontentConfig';
    }

}